import { useFintalkCloud } from 'contexts/FintalkCloud/fintalkCloudContext'
import { usePermissions } from 'contexts/Permissions/permissionsContext'
import { Actions } from 'contexts/Permissions/types'
import { useMemo } from 'react'

export interface HasAccessProps {
  children: React.ReactChild
  action: Actions[]
}

const WithHasAccess = ({ children, action }: HasAccessProps) => {
  const { currentData } = useFintalkCloud()
  const { companyName, agentName } = currentData
  const { hasPermission, isCompanyAdmin, isRoot } = usePermissions()
  // const { botName: agent, companyName: company } = useFlow().state;

  const verifyAccess = useMemo(() => {
    if (isRoot()) return true

    if (companyName && isCompanyAdmin(companyName)) return true

    if (companyName && agentName)
      return hasPermission({
        company: companyName,
        agent: agentName,
        permissions: currentData.permissions,
        actionPermissions: action,
      })
  }, [
    action,
    agentName,
    companyName,
    hasPermission,
    isCompanyAdmin,
    isRoot,
    currentData.permissions,
  ])

  return !!verifyAccess ? <>{children}</> : null
}

export default WithHasAccess
